<template>
    <AuthenticatedLayout>
      <div class="settings">
        <!-- Cabeçalho -->
        <header class="settings-header">
          <h2>Configurações | {{ segment }}</h2>          
            <!-- Botão para alternar entre tabela e kanban -->
            <el-segmented v-model="segment" :options="menuSegment" @change="handleSegment" />
        </header>
  
        <component :is="currentComponent" />
        


      </div>
    </AuthenticatedLayout>
  </template>
  
<script>
import AuthenticatedLayout from "@/layouts/AuthenticatedLayout.vue";  

import SettingsAccount from "@/components/SettingsAccount";
import SettingsPlan from "@/components/SettingsPlan";
import SettingsTaskCategories from "@/components/SettingsTaskCategories";
import SettingsClientCategories from "@/components/SettingsClientCategories";
import SettingsNotifications from "@/components/SettingsNotifications";
import SettingsUserCategories from "@/components/SettingsUserCategories.vue";

export default {
    name: "SettingsView",
    components: {
        AuthenticatedLayout,
        SettingsAccount,
        SettingsPlan,
        SettingsTaskCategories,
        SettingsClientCategories,
        SettingsNotifications,
        SettingsUserCategories
    },
    data() {
        return {
            urlApi: process.env.VUE_APP_API_URL,
            segment: 'Sua Empresa',
            menuSegment: [
                'Sua Empresa',
                // 'Seu Plano', 
                'Categoria de Tarefas', 
                'Categoria de Clientes', 
                'Perfil de Usuários', 
                'Notificações'
            ],
            componentSegment: {
                'Sua Empresa': "SettingsAccount",
                'Seu Plano': "SettingsPlan", 
                'Categoria de Tarefas': "SettingsTaskCategories", 
                'Categoria de Clientes': "SettingsClientCategories", 
                'Perfil de Usuários': "SettingsUserCategories",
                'Notificações': "SettingsNotifications",
            },        
        };
    },    
    methods: {
        handleSegment() {
            console.log('segmento escolhido > ', this.segment)
        },    
    },
    computed: {
        currentComponent() {
            return this.componentSegment[this.segment]
        }
    }
};
</script>

<style scoped>
.custom-style .el-segmented {
    --el-segmented-item-selected-color: var(--el-text-color-primary);
    --el-segmented-item-selected-bg-color: #ffd100;
    --el-border-radius-base: 16px;
  }
.settings-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}
.settings-header h2 {
    font-size: 24px;
    margin: 0;
}
.notification-icon {
    cursor: pointer;
}
</style>
